import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { HierarchyAllItemsVisibilityCell } from "@/components/pages/common/hierarchy-all-items/components/cell-renderers/HierarchyAllItemsVisibilityCell";
import { hierarchyFolderNoItemsText } from "@/store/common/utils/helpers/getHierarchyAllItemsFolderChildren";
import { HierarchyFolderItem } from "@/store/navigation/utils/types";

export const HierarchyAllItemsVisibilityCellRenderer: FC<
  CustomCellRendererProps<HierarchyFolderItem>
> = ({ data, node }) => {
  if (
    !data?.visibility ||
    data?.name === hierarchyFolderNoItemsText ||
    node.footer
  ) {
    return null;
  }

  return <HierarchyAllItemsVisibilityCell visibility={data.visibility} />;
};
